module.exports = __webpack_public_path__ + "img/p37.df4f68c1.svg";